import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/sections/page-hero'
import { Testimonials } from '@/components/sections/testimonials'
import { Benefit } from '@/components/sections/benefit'
import { Cta } from '@/components/sections/cta'

const Reviews: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Reviews'
                description='NG Painting Pro is rated 5.0 on Google from 25 reviews. Read what homeowners and businesses across Massachusetts say about our painting work.'
            />

            <PageHero
                title='Customer reviews'
                subtitle='Real feedback from homeowners and businesses who trusted us with their painting projects.'
                subtitleModifier='about'
            />

            <Testimonials heading='Trusted by 500+ customers' />
            <Benefit variant='services' />
            <Cta />
        </Layout>
    )
}

export default Reviews
